import http from '@/utils/request';
import global_ from '@/utils/Global'
let apiUrl_ZS = global_.BASE_URL_ZS;


/*获取数据列表*/
export const getDataList = params => {
  return http.requestPost(apiUrl_ZS + 'layout_footer/get_by_id', params)
}




// WEBPACK FOOTER //
// ./src/components/page/footer/api/footer.js